import script from "./echart_page.vue?vue&type=script&setup=true&lang=js"
export * from "./echart_page.vue?vue&type=script&setup=true&lang=js"

import "./echart_page.vue?vue&type=style&index=0&id=4617d8fd&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4617d8fd"]])

export default __exports__